import { DialogProps } from '@radix-ui/react-dialog';
import { ReactNode } from 'react';

import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '@/components/ui/dialog';

interface AlertModalProps extends DialogProps {
  title?: string;
  description?: string;
  onCancel?: () => void;
  onConfirm?: () => void;
  cancelButtonChildren?: ReactNode;
  confirmButtonChildren?: ReactNode;
  trigger?: ReactNode;
}

export const AlertModal = ({
  title = 'Вы точно хотите выйти из аккаунта?',
  description = '',
  onCancel,
  onConfirm,
  cancelButtonChildren = 'Отменить',
  confirmButtonChildren = 'Выйти из аккаунта',
  trigger,
  ...props
}: AlertModalProps) => {
  return (
    <Dialog {...props}>
      <DialogTrigger asChild={!!trigger && typeof trigger !== 'string'}>
        {trigger || 'Open'}
      </DialogTrigger>
      <DialogContent className="sm:rounded-3xl rounded-3xl w-[90%] max-w-[400px] bg-white">
        <DialogHeader className="text-center items-center">
          <DialogTitle className="text-xl font-semibold text-[#1B1D22] text-center">
            {title}
          </DialogTitle>
          <DialogDescription className={description ? undefined : 'sr-only'}>
            {description || title}
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="flex flex-row gap-3 !justify-center relative z-[60]">
          <Button
            variant="outline"
            onClick={() => {
              onCancel?.();
              props.onOpenChange?.(false);
            }}
            className="w-[84px] bg-[#F2F3F7] hover:bg-[#E8E9ED] text-gray-700 border-0 px-3 py-4 rounded-xl"
          >
            {cancelButtonChildren}
          </Button>
          <Button
            onClick={() => {
              onConfirm?.();
              props.onOpenChange?.(false);
            }}
            className="w-[146px] bg-[#F2F3F7] hover:bg-[#E8E9ED] text-[#FF5053] px-3 py-4 rounded-xl"
          >
            {confirmButtonChildren}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
